let globalIdCounter = 0;

export const getUniqueId = (): string => {
    globalIdCounter++;
    return `ux-unique-id-${globalIdCounter}`;
};
